// extracted by mini-css-extract-plugin
export default {"paginationListItem":"PagingTable_paginationListItem__AnupG","paginationOtherItem":"PagingTable_paginationOtherItem__xxqD2"};